import PulsoidClient from '../PulsoidClient';
import {SETUP_STEPS_ARRAY, SETUP_STEP_TYPES} from './SetupStepTypes';

export async function getPulsoidSetupConfiguration() {
  let checkedSteps = new Set<SETUP_STEP_TYPES>(['get-started']);
  const userInfo = await new PulsoidClient().getUserInfo();

  let streamed = !!userInfo.isUserStreamed;
  let loggedIn = !!userInfo.isUserLoggedInMobile;
  let premium = userInfo.premium ? !!userInfo.premium.isPremium : false;

  if (loggedIn) {
    checkedSteps.add('mobile-app');
  }
  if (premium) {
    checkedSteps.add('bro-plan');
  }
  if (streamed) {
    checkedSteps
      .add('heart-rate-monitors')
      .add('mobile-app')
      .add('configure-widgets')
      .add('go-live');
  }

  return {
    completedSteps: checkedSteps,
    completedStepsCount: checkedSteps.size,
    totalStepsCount: SETUP_STEPS_ARRAY.length,
  };
}
